import { useEffect, useRef, useState } from 'react';

export const useMsgContent = ({
  content,
  setDelay,
  initDelay,
  duration,
  oneLineDuration,
}) => {
  const contentRef = useRef();

  const [lines, setLines] = useState(null);
  const [currentLine, setCurrentLine] = useState('');

  const currentIdx = useRef(0);

  useEffect(() => {
    if (!lines) {
      return;
    }

    const newDelay = Math.max(duration, lines.length * oneLineDuration);

    setDelay(newDelay + initDelay * 1000);

    let idInterval = '';

    let idTimeout = setTimeout(() => {
      if (currentIdx.current === 0) {
        setCurrentLine(lines[currentIdx.current]);

        currentIdx.current = currentIdx.current + 1;
      }

      idInterval = setInterval(() => {
        if (currentIdx.current === lines.length) {
          setDelay(duration);
          clearInterval(idInterval);
          return;
        }

        setCurrentLine(lines[currentIdx.current]);
        currentIdx.current = currentIdx.current + 1;
      }, oneLineDuration);
    }, initDelay * 1000);

    return () => {
      clearInterval(idInterval);
      clearTimeout(idTimeout);
    };
  }, [lines, initDelay, duration, oneLineDuration]);

  useEffect(() => {
    const updateLines = () => {
      if (!contentRef.current || !content) return;

      const container = contentRef.current;
      const containerWidth = container.clientWidth;

      const words = content.split(' ');
      const lines = [];
      let currentLine = '';
      let tempSpan = document.createElement('span');

      tempSpan.style.visibility = 'hidden';
      tempSpan.style.whiteSpace = 'nowrap';

      container.appendChild(tempSpan);

      words.forEach((word, index) => {
        const testLine = currentLine ? `${currentLine} ${word}` : word;
        tempSpan.textContent = testLine;

        if (tempSpan.offsetWidth > containerWidth && currentLine !== '') {
          lines.push(currentLine);
          currentLine = word;
        } else {
          currentLine = testLine;
        }

        if (index === words.length - 1) {
          lines.push(currentLine);
        }
      });

      container.removeChild(tempSpan);
      setLines(lines);
    };

    updateLines();

    const handleResize = () => {
      updateLines();
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [content]);
  return {
    contentRef,
    currentLine,
  };
};
